import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import shareLinkApi from '~/shareLinkApi';

interface ISetShareLinkAccessProps {
  shareLinkId: string;
  email: string | null;
}

export const useSetShareLinkAccess = () => {
  return useMutation<AxiosResponse, AxiosError, ISetShareLinkAccessProps>(
    ({ shareLinkId, email }) =>
      shareLinkApi.post(
        `/share-links/${shareLinkId}/access`,
        email && { email },
      ),
  );
};
